import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MistService } from '@app/features/mists/shared/mist.service';
import { MistSiteCardComponent } from '@app/features/mists/modules/guest-wifi/components/site-card/site-card.component';

@Component({
    selector: 'app-mist-guest-wifi',
    templateUrl: './guest-wifi.component.html',
    styleUrls: ['./guest-wifi.component.css'],
    standalone: false
})
export class MistGuestWifiComponent implements OnInit {

    @ViewChild(MistSiteCardComponent) siteComponent: MistSiteCardComponent;

    isLoading = false;
    storeNumber: string;
    siteGroups: any;
    site: any;
    guestWifi: boolean;

    constructor(private mistService: MistService) { }

    async ngOnInit() {
        this.isLoading = true;
        (await this.mistService.getSitegroups()).toPromise().then( (sitegroups) => {
            this.siteGroups = sitegroups["message"];
            this.isLoading = false;
        });
    }

    async getSite() {
        this.isLoading = true;
        (await this.mistService.getSite(this.storeNumber)).toPromise().then( (site) => {
            this.site = site["message"];
            if (this.site != null) {
                let customerWifiDisabledSitegroupId = this.getCustomerWifiDisabledSitegroupId();
                if (this.site.hasOwnProperty('sitegroup_ids') && this.site['sitegroup_ids'].length > 0) {
                    for (let i = 0; i < this.site['sitegroup_ids'].length; i++) {
                        if (this.site["sitegroup_ids"][i] == customerWifiDisabledSitegroupId) {
                            this.guestWifi = true;
                        }
                    }
                } else {
                    this.guestWifi = false;
                }
            }
            this.isLoading = false;
        });
    }

    async updateGuestWifi() {
        this.isLoading = true;
        let sitegroup= this.getCustomerWifiDisabledSitegroupId()
        if (this.guestWifi) {
            (await this.mistService.addSitegroup(this.site["id"], sitegroup)).toPromise().then( (site) => {
                this.isLoading = false;
            });
        } else {
            (await this.mistService.removeSiteGroup(this.site["id"], sitegroup)).toPromise().then( (site) => {
                this.isLoading = false;
            });
        }
    }

    getCustomerWifiDisabledSitegroupId() {
        for (let i = 0; i < this.siteGroups.length; i++) {
            
            if (this.siteGroups[i]["name"] == "Customer Wi-Fi Off-Closed-Hours" && this.site["org_id"] == this.siteGroups[i]["org_id"]) {
                return this.siteGroups[i]["id"];
            }
        }
    }

}